import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1245af5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "GroundWork" }
const _hoisted_2 = { id: "section1" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"ProgressFld\" data-v-1245af5e><div class=\"progBar\" data-v-1245af5e><p class=\"bar\" data-v-1245af5e></p></div></div><div class=\"QuestionFld\" data-v-1245af5e><div class=\"QuestionText\" data-v-1245af5e>居住エリアを<br data-v-1245af5e>教えてください</div></div>", 2)
const _hoisted_5 = { class: "AnserFld" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_baind = _resolveDirective("baind")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.InitialValue) = $event)),
          class: "AnserMenue"
        }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Area, (item, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("option", null, [
              _createTextVNode(_toDisplayString(item.name), 1)
            ])), [
              [_directive_baind, i, "kye"]
            ])
          }), 256))
        ], 512), [
          [_vModelSelect, _ctx.InitialValue]
        ])
      ])
    ])
  ]))
}